import { PriceRule } from 'common/modules/discountCodes/types';
import { TFunction } from 'i18next';

const errorsTexts = (t: TFunction) => ({
	EMPTY_VALUE: t('discount.discountValueCannotBeEmpty', 'Discount value can not be empty.'),
	OVER_100_PERCENTAGE: t('discount.error_over_100_percent', 'Discount value can not be over 100%.'),
});

export const validateCode = (code: string, t: TFunction) => {
	if (!code) {
		return t('common:validation.cannotBeEmpty', {
			field: t('discount.discountCode', 'Discount code'),
			defaultValue: '{{field}} cannot be empty',
		});
	}
	return;
};

export const validateDiscountPriceRule = (priceRule: PriceRule, t: TFunction) => {
	const { valueType, value } = priceRule;
	if (!value) {
		return errorsTexts(t).EMPTY_VALUE;
	}
	if (valueType === 'percentage' && value > 100) {
		return errorsTexts(t).OVER_100_PERCENTAGE;
	}
	return;
};
